import { apiGet, apiPost } from './client';
import type { LoginResponse, Me } from './types';

export type LoginInput = {
  email: string;
  password: string;
  captcha?: string;
  captchaId?: string;
  hcaptchaToken?: string;
  mfaCode?: string;
};

export type InviteLookup = {
  email: string;
  userType: 'internal' | 'external';
  merchantId: string | null;
  merchantName: string | null;
  roleName: string | null;
  invitedBy: string;
  expiresAt: string;
};

export type AcceptInviteInput = {
  token: string;
  password: string;
  accountName: string;
};

export const authApi = {
  getCaptcha: () => apiGet<{ captchaId: string; code: string }>('/api/auth/captcha'),
  login: (input: LoginInput) => apiPost<LoginResponse>('/api/auth/login', input),
  logout: () => apiPost<{ ok: true }>('/api/auth/logout'),
  refresh: () => apiPost<{ ok: true; refreshed: boolean; expiresIn: number; token?: string }>(
    '/api/auth/refresh',
  ),
  me: () => apiGet<Me>('/api/auth/me'),
  verifyPassword: (password: string) =>
    apiPost<{ ok: true }>('/api/auth/verify-password', { password }),
  lookupInvite: (token: string) => apiGet<InviteLookup>(`/api/auth/invite/${encodeURIComponent(token)}`),
  acceptInvite: (input: AcceptInviteInput) => apiPost<LoginResponse>('/api/auth/invite/accept', input),
};
